import React, { useEffect } from "react";
import { Grid, Switch, FormControlLabel } from "@mui/material";
import { ModalV2 } from "../../components/Modal/ModalV2";
import { AutocompleteComponent } from "../../components/Autocomplete/AutocompleteComponent";
import { cancelInvoiceReason } from "../../helpers/cancelInvoiceReason";

export const CancelInvoiceModal = ({
  open,
  onClose,
  onSubmit,
  isLoading,
  disabledBtn,
  reason,
  handleNewValues,
  showMigrationSwitch,
  cancelNoteMigrations,
  setCancelNoteMigrations,
}) => {
  // Solo limpia el motivo: el formulario es compartido con los otros modales
  useEffect(() => {
    if (open) handleNewValues({ reason: cancelInvoiceReason?.[0] || null });
  }, [open]);

  return (
    <ModalV2
      title="¿Desea cancelar esta factura?"
      open={open}
      onClose={onClose}
      justConfirm
      onSubmit={onSubmit}
      isLoading={isLoading}
      disabledBtn={disabledBtn}
    >
      <Grid item xs={12}>
        <AutocompleteComponent
          id="combo-box-reassons"
          options={cancelInvoiceReason}
          value={reason}
          name="reason"
          label="Motivo de la cancelación"
          handleValues={handleNewValues}
        />
      </Grid>
      {showMigrationSwitch && (
        <Grid item xs={12} style={{ marginTop: 12 }}>
          <FormControlLabel
            control={
              <Switch
                checked={cancelNoteMigrations}
                onChange={(e) => setCancelNoteMigrations(e.target.checked)}
                color="primary"
              />
            }
            label="Cancelar migraciones de notas a Oracle asociadas"
          />
        </Grid>
      )}
    </ModalV2>
  );
};
